import React from "react";

const PageHeader = ({ title, subtitle, actions, testid }) => {
  return (
    <div
      className="flex flex-col lg:flex-row items-end justify-between gap-4 px-8 pt-8 pb-6 border-b border-border bg-white"
      data-testid={testid}
    >
      <div>
        <div className="label-overline mb-1.5">Painel SEFAZ</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-semibold leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
};

export default PageHeader;
